define.alias("shared/utils/formatters/pin-from-dynamo", "calendar/utils/formatters/pin-from-dynamo");